import React, { forwardRef } from "react";

import { StyledBox } from "./style";

const Button = forwardRef(function Button(props, ref) {
  return <StyledBox ref={ref} disableElevation={true} {...props} />;
});

Button.propTypes = {
  ...StyledBox.propTypes,
};

export default Button;
